import axios from "../utils/axios";

/**
 * List all brands with pagination and filtering
 * @param {Object} params - Query parameters (page, per_page, search, is_active)
 * @returns {Promise} Brands list
 */
export const getBrands = async (params) => {
    try {
        const { data } = await axios.get('/admin/brands', { params });
        return data;
    } catch (error) {
        console.error("🚀 ~ getBrands ~ error:", error);
        throw error;
    }
};

/**
 * Get a single brand by ID
 * @param {number|string} id - Brand ID
 * @returns {Promise} Brand data
 */
export const getBrandById = async (id) => {
    try {
        const { data } = await axios.get(`/admin/brands/${id}`);
        return data;
    } catch (error) {
        console.error("🚀 ~ getBrandById ~ error:", error);
        throw error;
    }
};

/**
 * Create a new brand
 * @param {Object|FormData} brandData - Brand data
 * @returns {Promise} Created brand
 */
export const createBrand = async (brandData) => {
    try {
        const { data } = await axios.post('/admin/brands', brandData);
        return data;
    } catch (error) {
        console.error("🚀 ~ createBrand ~ error:", error);
        throw error;
    }
};

/**
 * Update an existing brand
 * @param {number|string} id - Brand ID
 * @param {Object|FormData} brandData - Updated data
 * @returns {Promise} Updated brand
 */
export const updateBrand = async (id, brandData) => {
    try {
        const { data } = await axios.post(`/admin/brands/${id}`, brandData);
        return data;
    } catch (error) {
        console.error("🚀 ~ updateBrand ~ error:", error);
        throw error;
    }
};

/**
 * Delete a brand
 * @param {number|string} id - Brand ID
 * @returns {Promise} Result
 */
export const deleteBrand = async (id) => {
    try {
        const { data } = await axios.delete(`/admin/brands/${id}`);
        return data;
    } catch (error) {
        console.error("🚀 ~ deleteBrand ~ error:", error);
        throw error;
    }
};

/**
 * Reorder brands
 * @param {Array} items - Array of {id, sort_order}
 * @returns {Promise} Result
 */
export const reorderBrands = async (items) => {
    try {
        const { data } = await axios.post('/admin/brands/reorder', { items });
        return data;
    } catch (error) {
        console.error("🚀 ~ reorderBrands ~ error:", error);
        throw error;
    }
};
